import { Link } from "react-router-dom";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { useUserDataContext } from "../context/UserDataContext";
import useMobile from "../hooks/useMobile";
import DynamicToolTip from "./DynamicToolTip";
import { Box, Divider, Menu, Typography } from "@mui/material";
import { useState } from "react";
import Logout from "./Logout";
import PasswordPopUp from "./PasswordPopUp";

const Header = () => {
  const [openPopUp, setOpenPopUp] = useState<boolean>(false);
  const mobile = useMobile();
  const { userData } = useUserDataContext();
  const { companyDetailsData } = useCompanyDetailsContext();
  const userPage =
    window.location.pathname.includes("admin/") ||
    window.location.pathname.includes("member/");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  return (
    <>
      <div className={`main-header-two__top ${userPage && "fixed-header"}`}>
        <div className="container">
          <div className="main-header-two__top-inner">
            <div className="main-header-two__logo" style={{ display: "flex" }}>
              <a href="/" style={{ paddingRight: "10px" }}>
                <img
                  height={mobile ? "40" : "60"}
                  src={
                    companyDetailsData[0]?.logo[0]?.media?.url
                      ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.logo[0]?.media?.url}`
                      : undefined
                  }
                  alt="logo"
                />
              </a>
              <div className="main-header-two__search-cart-donate-btn custom-main-header-details-div">
                <div className="custom-main-header-details">
                  <h4 style={{ fontSize: "13px" }}>
                    {companyDetailsData[0]?.company_name}
                  </h4>
                  <p style={{ fontSize: "12px", marginBottom: "unset" }}>
                    (Reg. No: RJN-4-00532-2014-15 on 26/2/2015)
                  </p>
                </div>
              </div>
            </div>
            <div className="main-header-two__right">
              <div className="main-header-two__search-cart-donate-btn">
                {userPage ? (
                  <>
                    <DynamicToolTip title={userData?.data?.name}>
                      <div
                        style={{
                          display: "inline-block",
                          marginLeft: "20px",
                          marginRight: "20px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                      >
                        {userData ? (
                          <span className="main-header-two__cart icon-user mini-cart__toggler">
                            <p className="user-name">{`Hi, ${userData?.data?.name}`}</p>
                          </span>
                        ) : (
                          <span className="main-header-two__cart icon-user mini-cart__toggler"></span>
                        )}
                      </div>
                    </DynamicToolTip>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={() => setAnchorEl(null)}
                      disableScrollLock={true}
                      PaperProps={{
                        elevation: 3,
                        sx: {
                          overflow: "visible",
                          mt: 1.5,
                          borderRadius: 2,
                          width: 250,
                          // backgroundColor: "#f2f0ec",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            // backgroundColor: "#ffa415",
                            top: 0,
                            right: 20,
                            width: 10,
                            height: 10,
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: -1,
                            boxShadow: "-1px -1px 1px rgba(0,0,0,0.05)",
                          },
                        },
                      }}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <Box px={2} py={1}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {userData?.data?.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {userData?.data?.email}
                        </Typography>
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      {/* <MenuItem onClick={handleChangePassword}>
                      <LockResetOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
                      Change Password
                    </MenuItem> */}
                      <Box px={2} py={1}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            cursor: "pointer",
                            display: "inline-flex",
                            gap: "5px",
                            alignItems: "center",
                            "&:hover": {
                              color: "#43b3f8",
                            },
                          }}
                          onClick={() => {
                            setOpenPopUp(true);
                            setAnchorEl(null);
                          }}
                        >
                          <span className="icon-key"></span>
                          Change Password
                        </Typography>
                      </Box>
                      <Logout />
                    </Menu>
                  </>
                ) : (
                  <DynamicToolTip
                    title={userData ? "Member Dashboard" : "Login"}
                  >
                    <a
                      href="/login"
                      style={{
                        display: "inline-block",
                        marginLeft: "20px",
                        marginRight: "20px",
                      }}
                    >
                      {userData ? (
                        <span className="main-header-two__cart icon-user mini-cart__toggler">
                          <p className="user-name">{`Hi, ${userData.data.name}`}</p>
                        </span>
                      ) : (
                        <span className="main-header-two__cart icon-user mini-cart__toggler"></span>
                      )}
                    </a>
                  </DynamicToolTip>
                )}
                {!userData &&
                  (!mobile ? (
                    <Link
                      to="/become-a-member"
                      className="thm-btn main-header-two__btn custom-donate-btn"
                      style={{ paddingLeft: "5px" }}
                    >
                      <i className="icon-user-plus"></i>
                      Become a Member
                    </Link>
                  ) : (
                    <a
                      href="/become-a-member"
                      style={{ paddingTop: mobile ? "5px" : "unset" }}
                    >
                      <span className="main-header-two__cart icon-user-plus mini-cart__toggler"></span>
                    </a>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PasswordPopUp open={openPopUp} setOpen={setOpenPopUp} />
    </>
  );
};

export default Header;
